<template>
    <div class="accountManagement">
        <!-- <el-dialog v-model="pageData.dialogPhoneShow" width="29%" center title="手机号修改">
            <div class="dialogView">
                <div class="itemView">
                    <div class="title_">原手机号</div>

                    <div class="txt_">
                        {{ pageData.userInformation.phone }}
                    </div>

                    <div class="button_"></div>
                </div>
                <div class="itemView" v-if="pageData.typeShow == 2">
                    <div class="title_">绑定手机</div>

                    <div class="input_">
                        <input type="text" v-model="pageData.phoneData.phone" placeholder="请输入" />
                    </div>

                    <div class="button_"></div>
                </div>
                <div class="itemView" v-if="pageData.typeShow == 1">
                    <div class="title_">验证码</div>

                    <div class="input_">
                        <input type="text" v-model="pageData.phoneData.oldVerificationCode" placeholder="请输入" />
                    </div>

                    <div class="button_" @click="getCode(pageData.userInformation.phone, 4)">
                        {{ pageData.show ? "获取验证码" : pageData.count }}
                    </div>
                </div>
                <div class="itemView" v-else>
                    <div class="title_">验证码</div>

                    <div class="input_">
                        <input type="text" v-model="pageData.phoneData.verificationCode" placeholder="请输入" />
                    </div>

                    <div class="button_" @click="getCode(pageData.phoneData.phone, 3)">
                        {{ pageData.show ? "获取验证码" : pageData.count }}
                    </div>
                </div>
            </div>
            <template #footer>
                <div class="dialogButton" @click="nextFun(pageData.typeShow)">
                    下一步
                </div>
            </template>
        </el-dialog> -->

        <el-dialog v-model="pageData.dialogPassWordShow" width="29%" center title="修改密码">
            <div class="dialogView">
                <!-- <div class="itemView">
                    通过已绑定手机号{{ pageData.userInformation.phone }}进行验证
                </div> -->
                <!-- <div class="itemView">
                    <div class="title_">验证码</div>

                    <div class="input_">
                        <input type="text" v-model="pageData.passWordData.verificationCode" placeholder="请输入" />
                    </div>

                    <div class="button_" @click="getCode(pageData.userInformation.phone, 5)">
                        {{ pageData.show ? "获取验证码" : pageData.count }}
                    </div>
                </div> -->
                <div class="itemView">
                    <div class="title_">老密码</div>

                    <div class="input_">
                        <input type="password" v-model="pageData.passWordData.oldPassWord" placeholder="请输入" />
                    </div>

                    <div class="button_"></div>
                </div>
                <div class="itemView">
                    <div class="title_">新密码</div>

                    <div class="input_">
                        <input type="password" v-model="pageData.passWordData.passWord" placeholder="请输入" />
                    </div>

                    <div class="button_"></div>
                </div>
                <div class="itemView">
                    <div class="title_">再次输入</div>

                    <div class="input_">
                        <input type="password" v-model="pageData.passWordData.newpassWord" placeholder="请输入" />
                    </div>

                    <div class="button_"></div>
                </div>
            </div>
            <template #footer>
                <div class="dialogButton" @click="passWordSetting">提交</div>
            </template>
        </el-dialog>
        <div class="titleView">账号详情</div>
        <div class="contentView">
            <div class="title_">注册信息</div>
            <div class="registrationInformation">
                <div class="poster_">
                    <div class="img_">
                        <img src="@/assets/images/userLogo.png" />
                    </div>
                    <div class="txt_">
                        <div>{{ pageData.userInformation.name }}</div>
                        <!-- <div></div> -->
                    </div>
                </div>
                <div class="userDataView">
                    <div class="itemTitle">绑定手机</div>
                    <div class="itemValue">{{ pageData.userInformation.phone }}</div>
                    <!-- <div class="itemBtn" @click="pageData.dialogPhoneShow = true">
                        更换手机
                    </div> -->
                </div>
                <div class="userDataView">
                    <div class="itemTitle">登录密码</div>
                    <div class="itemValue">已设置</div>
                    <div class="itemBtn" @click="pageData.dialogPassWordShow = true">
                        修改
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { reactive } from "vue";
import Cookies from "js-cookie";
import { ElMessage } from "element-plus";
import {
    smsTemplateSendMsgSecond,
    // userVaildPhoneCode,
    // userUpdatePhone,
    userUpdatePassWord,
} from "../api/interfaceList";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
    name: "accountManagement",
    setup() {
        const router = useRouter();
        const store = useStore();
        let pageData = reactive({
            typeShow: 1,
            dialogPhoneShow: false,
            dialogPassWordShow: false,
            userInformation: JSON.parse(Cookies.get("userInformation")),
            show: true,
            count: "",
            timer: null,

            phoneData: {
                phone: "",
                oldVerificationCode: "",
                verificationCode: "",
            },

            passWordData: {
                verificationCode: "",
                passWord: "",
                oldPassWord: "",
            },
        });

        function passWordSetting() {
            if (pageData.passWordData.passWord == pageData.passWordData.newpassWord) {
                userUpdatePassWord({
                    newPassword: pageData.passWordData.passWord,
                    oldPassword: pageData.passWordData.oldPassWord,
                    userCode: pageData.userInformation.userCode,
                }).then((res) => {
                    if (res.code == 1) {
                        Cookies.remove("userInformation");
                        store.commit("isLoginSetting", true);
                        router.push({
                            path: "/userAccountSettings",
                        });
                    } else {
                        ElMessage(res.message);
                    }
                });
            } else {
                ElMessage({
                    message: "密码不一致",
                    type: "warning",
                });
            }
        }

        // function nextFun() {
        //     if (pageData.typeShow == 1) {
        //         userVaildPhoneCode({
        //             phone: pageData.userInformation.phone,
        //             verificationCode: pageData.phoneData.oldVerificationCode,
        //         }).then((res) => {
        //             if (res.code == 1) {
        //                 pageData.typeShow = 2;
        //                 pageData.show = true;
        //                 clearInterval(pageData.timer);
        //                 pageData.timer = null;
        //             } else {
        //                 ElMessage(res.message);
        //             }
        //         });
        //     } else {
        //         userUpdatePhone({
        //             oldVerificationCode: pageData.phoneData.oldVerificationCode,
        //             phone: pageData.phoneData.phone,
        //             userCode: pageData.userInformation.userCode,
        //             verificationCode: pageData.phoneData.verificationCode,
        //         }).then((res) => {
        //             if (res.code == 1) {
        //                 Cookies.remove("userInformation");
        //                 store.commit("isLoginSetting", true);
        //                 router.push({
        //                     path: "/userAccountSettings",
        //                 });
        //             } else {
        //                 ElMessage(res.message);
        //             }
        //         });
        //     }
        // }
        function getCode(value, type) {
            if (value) {
                if (pageData.userInformation.phone) {
                    smsTemplateSendMsgSecond({
                        phone: value,
                        type: type,
                    }).then((res) => {
                        if (res.code == 1) {
                            const TIME_COUNT = 60;
                            if (!pageData.timer) {
                                pageData.count = TIME_COUNT;
                                pageData.show = false;
                                pageData.timer = setInterval(() => {
                                    if (pageData.count > 0 && pageData.count <= TIME_COUNT) {
                                        pageData.count--;
                                    } else {
                                        pageData.show = true;
                                        clearInterval(pageData.timer);
                                        pageData.timer = null;
                                    }
                                }, 1000);
                            }
                        } else {
                            ElMessage(res.message);
                        }
                    });
                } else {
                    ElMessage("请输入手机号");
                }
            } else {
                ElMessage("请输入手机号");
            }
        }
        return {
            pageData,
            getCode,
            // nextFun,
            passWordSetting,
        };
    },
};
</script>
<style lang="scss">
.accountManagement {
    .el-dialog {
        width: 450px;
    }

    .el-dialog__header {
        text-align: left;
        margin: 0;

        .el-dialog__title {
            font-size: 13px;
            font-family: AlibabaPuHuiTiR;
            color: #606266;
        }
    }
}
</style>
<style lang="scss" scope>
.accountManagement {
    width: 1050px;
    background: #ffffff;
    border-radius: 8px;
    padding: 16px 30px;
    box-sizing: border-box;
    text-align: left;

    //   padding-bottom: 30px;
    .dialogButton {
        width: 100%;
        height: 40px;
        font-size: 14px;
        font-family: AlibabaPuHuiTiM;
        color: #ffffff;
        line-height: 40px;
        text-align: center;
        background: #008aea;
        border-radius: 8px;
        cursor: pointer;
    }

    .dialogButton:hover {
        background: #6dbbfc;
        transition: 0.4s all;
    }

    .dialogView {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;

        // .itemView:last-of-type {
        //   margin: 0;
        // }
        .itemView {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 24px;

            .button_ {
                width: 90px;
                height: 24px;
                font-size: 13px;
                font-family: AlibabaPuHuiTiR;
                color: #008aea;
                line-height: 24px;
                cursor: pointer;
                text-align: right;
            }

            .txt_ {
                width: 240px;
            }

            .input_ {
                width: 240px;
                height: 40px;
                border-radius: 6px;
                border: 1px solid #cccccc;
                padding: 8px;
                box-sizing: border-box;

                input {
                    width: 100%;
                    height: 100%;
                    outline: none;
                    background: none;
                    border: none;
                    font-size: 13px;
                    font-family: AlibabaPuHuiTiR;
                    color: #909399;
                }
            }

            .title_ {
                width: 56px;
                font-size: 12px;
                font-family: AlibabaPuHuiTiR;
                color: #303133;
                line-height: 24px;
            }
        }
    }

    .contentView {
        width: 100%;

        .title_ {
            font-size: 16px;
            font-family: AlibabaPuHuiTiM;
            color: #303133;
            margin: 16px 0;
            font-weight: 700;
        }

        .registrationInformation {
            .userDataView {
                display: flex;
                align-items: center;
                margin-top: 16px;
                font-weight: 700;

                .itemBtn {
                    font-size: 13px;
                    font-family: AlibabaPuHuiTiR;
                    color: #008aea;
                    cursor: pointer;
                }

                .itemValue {
                    width: 432px;
                    height: 40px;
                    line-height: 40px;
                    background: #f2f2f2;
                    border-radius: 6px;
                    padding-left: 8px;
                    box-sizing: border-box;
                    font-size: 13px;
                    font-family: AlibabaPuHuiTiR;
                    color: #909399;
                    margin: 0 10px;
                }

                .itemTitle {
                    width: 88px;
                    font-size: 12px;
                    font-family: AlibabaPuHuiTiR;
                    color: #303133;
                }
            }

            .poster_ {
                display: flex;
                align-items: center;

                .txt_ {
                    div:nth-of-type(1) {
                        font-size: 14px;
                        font-family: AlibabaPuHuiTiB;
                        color: #606266;
                    }

                    div:nth-of-type(2) {
                        margin-top: 6px;
                        font-size: 12px;
                        font-family: AlibabaPuHuiTiR;
                        color: #909399;
                    }
                }

                .img_ {
                    width: 60px;
                    height: 60px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 50%;
                    overflow: hidden;
                    margin-right: 16px;

                    img {
                        width: 100%;
                    }
                }
            }
        }
    }

    .titleView {
        font-size: 14px;
        font-family: AlibabaPuHuiTiM;
        color: #303133;
        line-height: 64px;
        border-bottom: 1px #f5f7fa solid;
        text-align: left;
        font-weight: 700;
    }
}
</style>
